import React, { useState } from 'react'
import {
  TextField,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  FormHelperText
} from '@mui/material'
import { useFormik } from 'formik'
import MyButton from '../../ui/MyButton'
import { connect } from 'react-redux'
import { addReview } from '../../../actions/review'
import { useParams } from 'react-router-dom'
import { Rating } from '@mui/material';
import { Star } from '@mui/icons-material'
import * as yup from 'yup'

const AddReview = ({
  openAddReviewDialog,
  handleClose,
  addReview,
  teacherId,
}) => {
  const [hover, setHover] = useState(-1)

  const { bookedLessonId } = useParams()

  const labels = {
    0.5: 'Không hiệu quả',
    1: 'Không hiệu quả+',
    1.5: 'Kém',
    2: 'Kém+',
    2.5: 'Ổn',
    3: 'Ổn+',
    3.5: 'Tốt',
    4: 'Tốt+',
    4.5: 'Xuất sắc',
    5: 'Xuất sắc+'
  }

  const validationSchema = yup.object({
    rating: yup.number().required('Vui lòng chọn sao'),
    content: yup.string().required('Vui lòng điền nội dung')
  })

  const formik = useFormik({
    initialValues: {
      rating: undefined,
      content: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const { rating, content } = values

      const ratingTransformedToString = rating.toString()

      await addReview({ rating: ratingTransformedToString, content, teacher: teacherId, orderId: bookedLessonId })
      await handleClose()
    }
  })

  return (
    <Dialog
      open={openAddReviewDialog}
      onClose={handleClose}
      style={{ minWidth: '100%' }}
    >
      <DialogTitle style={{ textAlign: 'center', padding: '2em 2em 0' }}>Gửi nhận xét</DialogTitle>

      <DialogContent>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
          >
            <Grid item>
              <Box
                sx={{
                  width: 200,
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Rating
                  name="rating"
                  value={formik.values.rating}
                  precision={0.5}
                  onChange={formik.handleChange}
                  onChangeActive={(event, newHover) => {
                    setHover(newHover);
                  }}
                  emptyIcon={<Star style={{ opacity: 0.55 }} fontSize="inherit" />}
                />
                {formik.values.rating !== null && (
                  <Box sx={{ ml: 2 }}>{labels[hover !== -1 ? hover : formik.values.rating]}</Box>
                )}
              </Box>

              <FormHelperText error={formik.touched.rating && Boolean(formik.errors.rating)}>{formik.errors.rating}</FormHelperText>
            </Grid>

            <Grid item>
              <TextField
                style={{ width: 400 }}
                error={formik.touched.content && Boolean(formik.errors.content)}
                helperText={formik.touched.content && formik.errors.content}
                name='content'
                label="Nội dung"
                multiline
                value={formik.values.content}
                onChange={formik.handleChange}
                rows={5}
              />
            </Grid>

            <Grid
              item
              container
              justifyContent="center"
              align="center"
              spacing={1}
              style={{ paddingBottom: '2em' }}
            >
              <Grid item>
                <MyButton onClick={handleClose}>Đóng</MyButton>
              </Grid>

              <Grid item>
                <MyButton type="submit">Gửi</MyButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default connect(null, { addReview })(AddReview)
